module.exports = __webpack_public_path__ + "static/media/5fe324e2-1220-43b0-ae89-5f6ff7810f80.78a4e00e.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/5fe324e2-1220-43b0-ae89-5f6ff7810f80.jpg
// module id = 822
// module chunks = 0